import { Suspense } from 'react'
import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import type { JobDetailsViewLoaderData } from '@/features/jobs/job-route-loaders'
import { IamDialogsHost } from '@/features/iam/IamDialogsHost'
import { BillingDialogsHost } from '@/features/billing/BillingDialogsHost'
import { DocumentDialogsHost } from '@/features/documents/DocumentDialogsHost'
import { MobileJobRootContainer } from './MobileJobRootContainer'

export default observer(function MobileJobContainer() {
  const data = useLoaderData<JobDetailsViewLoaderData>()
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  // The mobile job renders outside the shell, so it hosts the app-wide
  // dialogs its views can open.
  return (
    <>
      <MobileJobRootContainer rootVm={internal.jobRootViewModel} data={data} />
      <Suspense fallback={null}>
        <IamDialogsHost />
        <BillingDialogsHost />
        <DocumentDialogsHost />
      </Suspense>
    </>
  )
})
